module.exports = __webpack_public_path__ + "img/icon_map_7_off_110.acb658c6.png";